const listAnys = () => {
  const actualYear = new Date().getFullYear();
  const years = [];
  for(let i=actualYear; i >=2015 ; i--) {
    years.push(i);
  }
  return years;
};

const listAnysWithAll = () => {
  
  const result = listAnys();
  return ['All', ...result];
};


const listAnysInversio = (availableYears) => {
  if (availableYears && Array.isArray(availableYears) && availableYears.length > 0) {
    return [...new Set(availableYears.map(Number))].sort((a, b) => b - a);
  }
  const currentYear = Math.max(new Date().getFullYear(), 2026);
  const years = [];
  for (let i = currentYear; i >= 2024; i--) {
    years.push(i);
  }
  return years;
};

const listMesos = [
    { key: 1, name: "Gener"}, 
    { key: 2, name: "Febrer"}, 
    { key: 3, name: "Març"}, 
    { key: 4, name: "Abril"}, 
    { key: 5, name: "Maig"}, 
    { key: 6, name: "Juny"}, 
    { key: 7, name: "Juliol"}, 
    { key: 8, name: "Agost"}, 
    { key: 9, name: "Setembre"}, 
    { key: 10, name: "Octubre"}, 
    { key: 11, name: "Novembre"}, 
    { key: 12, name: "Desembre"}
  ];

export {listAnys, listAnysWithAll, listMesos, listAnysInversio};